/**
 * @generated SignedSource<<23eddce7fe4262db364138946fd805b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReceiverStoresSelectorMain_receiverStore$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"OrgStoreWorkspaceBreadcrumbs_store">;
  readonly " $fragmentType": "ReceiverStoresSelectorMain_receiverStore";
};
export type ReceiverStoresSelectorMain_receiverStore$key = {
  readonly " $data"?: ReceiverStoresSelectorMain_receiverStore$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorMain_receiverStore">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReceiverStoresSelectorMain_receiverStore",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrgStoreWorkspaceBreadcrumbs_store"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "6768015ba88efc0d78dc73ff535457c8";

export default node;
